define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'jump',
        'slider-carousel-infinite-enhanced-vertical', 'slider-carousel-infinite-enhanced', 'preloader'],
    function ($, transit, modernizr, container, router, jumpFactory,
              sliderCarouselInfiniteEnhancedVerticalFactory, sliderCarouselInfiniteEnhancedFactory, preloader) {

        return (function () {

            const name = 'video';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            const slider = sliderCarouselInfiniteEnhancedVerticalFactory.create();
            const sliderMobile = sliderCarouselInfiniteEnhancedFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {
                actionSupriseCookie: function () {
                    $.ajax({
                        url: model.publicVars.ajaxSupriseCookieAction,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {

                    });
                }
            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                currentItem: {
                    id: null
                },
                changeItemAnim: 0
            };

            view.startup = function () {
                view.privateVars.currentItem.id = view.publicVars.currentItem.id;

                $(view.publicVars.cssId.moduleVideoSliderItemCls).removeAttr('href');
                $(view.publicVars.cssId.moduleVideoSliderMobileItemCls).removeAttr('href');

                preloader.setPreloadBulk(name, view.publicVars.preloadImgTab);
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleVideoSliderItemCls + ' ,' + view.publicVars.cssId.moduleVideoSliderMobileItemCls).click(function () {
                    const id = container.getData($(this)[0], 'id');

                    if(id != view.privateVars.currentItem.id && view.privateVars.changeItemAnim == 0) {
                        view.privateVars.changeItemAnim = 1;
                        view.methods.handleItemClick(id, this);
                    }

                    return false;
                });

                $(view.publicVars.cssId.moduleVideoEggSupriseId).click(function () {
                    if(view.privateVars.changeItemAnim == 0) {
                        view.privateVars.changeItemAnim = 1;
                        view.methods.handleEggHuntClick();
                    }
                });
            };

            view.methods = {
                handleItemClick: (id, handler) => {

                    const videoSrc = container.getData($(handler)[0], 'video.src');
                    const posterSrc = container.getData($(handler)[0], 'poster.src');
                    const content = container.getData($(handler)[0], 'content');
                    const metaTitle = container.getData($(handler)[0], 'meta.title');
                    const hrefTop = container.getData($(handler)[0], 'href.top');
                    const windowWidth = $(window).outerWidth();

                    const oldId = view.privateVars.currentItem.id;

                    view.privateVars.currentItem.id = id;

                    router.route(hrefTop, metaTitle, {});

                    $(view.publicVars.cssId.moduleVideoSliderItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.moduleVideoSliderMobileItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                    if($(view.publicVars.cssId.moduleVideoEggHuntVideoFrameCls).length > 0) {
                        $(view.publicVars.cssId.moduleVideoEggHuntVideoFrameCls).css({
                            display: 'none',
                        });

                        $(view.publicVars.cssId.moduleVideoEggHuntVideoFrameElemCls).remove();
                    }

                    $('#' + view.publicVars.cssId.moduleVideoSliderItemCls.substr(1) + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $('#' + view.publicVars.cssId.moduleVideoSliderMobileItemCls.substr(1) + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.moduleVideoFeaturedFrameLoaderWrapperId).css({ opacity: 0, scale: 0.5, rotate: '0deg' });

                    $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerId).transit({ opacity: 0, scale: 0.5}, 300, function () {
                        $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerAreaId).html(content);
                        $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerId).transit({ opacity: 1, scale: 1 });
                    });

                    // if(windowWidth < 768) {
                        jump.centerTo(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId, {});
                    // }

                    $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId).fadeOut(300, function () {

                        $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId)[0].src = '';

                        $(view.publicVars.cssId.moduleVideoFeaturedFrameLoaderWrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg' }, 300, function () {
                            setTimeout(function () {
                                $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId)[0].src = videoSrc;
                                $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId)[0].poster = posterSrc;
                                $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId)[0].play();

                                $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId).fadeIn(300, function () {
                                    view.privateVars.changeItemAnim = 0;
                                });
                            }, 500);
                        });


                    });
                    // $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId).attr('src', videoSrc);
                },

                handleEggHuntClick: () => {
                    view.privateVars.currentItem.id = null;

                    model.methods.actionSupriseCookie();

                    $(view.publicVars.cssId.moduleVideoEggSupriseId).removeClass(view.publicVars.cssId.animateAnimatedCls.substr(1));
                    $(view.publicVars.cssId.moduleVideoEggSupriseId).removeClass(view.publicVars.cssId.animateRotateInCls.substr(1));
                    $(view.publicVars.cssId.moduleVideoEggSupriseId).transit({ scale: 0, rotate: '360deg' }, 300);

                    $(view.publicVars.cssId.moduleVideoSliderItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.moduleVideoSliderMobileItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId).attr('src', '');

                    $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerId).transit({ opacity: 0, scale: 0.5}, 300, function () {
                        $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerAreaId).html(view.publicVars.egg.title);
                        $(view.publicVars.cssId.moduleVideoFeaturedFrameTxtInnerId).transit({ opacity: 1, scale: 1 });
                    });

                    jump.centerTo(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId, {});


                    $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId).fadeOut(300, function () {

                        $(view.publicVars.cssId.moduleVideoFeaturedFrameIframeId)[0].src = '';

                        $(view.publicVars.cssId.moduleVideoFeaturedFrameLoaderWrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg' }, 300, function () {
                            setTimeout(function () {
                                $(view.publicVars.cssId.moduleVideoEggHuntVideoFrameCls).css({ display: 'block', opacity: 0, scale: 0.5 });
                                $(view.publicVars.cssId.moduleVideoEggHuntVideoFrameCls).transit({ opacity: 1, scale: 1 }, 300, function () {
                                    view.privateVars.changeItemAnim = 0;
                                });
                            }, 500);
                        });


                    });
                },

                decorateSliderElement: (elem) => {
                    const id = parseInt(container.getData(elem[0], 'id'));

                    if (id === parseInt(view.privateVars.currentItem.id)) {
                        $(view.publicVars.cssId.moduleVideoSliderItemCls, elem).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else {
                        $(view.publicVars.cssId.moduleVideoSliderItemCls, elem).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    }

                    return elem;
                },

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    slider.init(options.sliderSetup);
                    slider.setElementDecorateCallback(view.methods.decorateSliderElement);

                    sliderMobile.init(options.sliderMobileSetup);
                    sliderMobile.setElementDecorateCallback(view.methods.decorateSliderElement);
                }
            };


        })();


    });
